import React from 'react';
import { Tag } from 'antd';

interface Props {
    status: App.ApplicationScoreLineItem['activity_progress'] | undefined;
}

/***
 * 開始前 or 開始 or 受験中 or 送信済み or 完了を きれいなタグとして表示する
 * @param props
 * @constructor
 */
export const ProgressStatusTag: React.FC<Props> = (props) => {
    switch (props.status) {
        case 'Initialized':
            return (
                <Tag color='#AAAAAA' style={{ width: '75px', textAlign: 'center', borderRadius: '5px' }}>
                    開始前
                </Tag>
            );
        case 'Started':
            return (
                <Tag color='#AAAAAA' style={{ width: '75px', textAlign: 'center', borderRadius: '5px' }}>
                    開始
                </Tag>
            );
        case 'InProgress':
            return (
                <Tag color='#AAAAAA' style={{ width: '75px', textAlign: 'center', borderRadius: '5px' }}>
                    受験中
                </Tag>
            );
        case 'Submitted':
            return (
                <Tag color='#AAAAAA' style={{ width: '75px', textAlign: 'center', borderRadius: '5px' }}>
                    送信済み
                </Tag>
            );
        case 'Completed':
            return (
                <Tag color='#118584' style={{ width: '75px', textAlign: 'center', borderRadius: '5px' }}>
                    完了
                </Tag>
            );
        default:
            return null;
    }
};
